import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormControl, FormGroup } from '@angular/forms';
import { ValidationService } from '../../services/formsValidation/validation.service';
import { FundingTypeLabel_EN } from 'src/app/models/labels/fundingTypeLabel_EN';
import { forwardRef } from '@angular/core';

@Component({
  selector: 'app-radio-three-button',
  templateUrl: './radio-three-button.component.html',
  styleUrls: ['./radio-three-button.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => RadioThreeButtonComponent),
    multi: true
  }]
})
export class RadioThreeButtonComponent implements OnInit {

  @Input() formErrors: any[];
  @Input() controlName: any;
  @Input() control: FormControl;
  @Input() labelName: string;
  @Input() value1: any;
  @Input() value2: any;
  @Input() value3: any;
  @Input() checkedValue: any;
  @Input() isMandatory: boolean = false;
  @Input() isDisableFirstValue: boolean = false;
  @Input() isDisableSecondValue: boolean = false;
  @Input() isDisableThirdValue: boolean = false;
  @Output() change = new EventEmitter<any>();


  selectedValue: any;
  label: any;

  propagateChange: (_: any) => void = () => {
  }
  parent: FormGroup;
  isOneChecked: boolean;
  isTwoChecked: boolean;
  isThreeChecked: boolean;

  constructor(private validationService: ValidationService) { }

  ngOnInit() {
    this.label = new FundingTypeLabel_EN();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['formErrors']) {
      this.formErrors = changes['formErrors'].currentValue;
      // this.parent = this.control.parent as FormGroup;
      // this.formErrors = this.validationService.validateForm(this.parent, this.formErrors,  false);
    }
    if (changes['checkedValue']) {
      if (this.checkedValue == this.value1) {
        this.isOneChecked = true;
        this.isTwoChecked = false;
        this.isThreeChecked = false;
      } else if (this.checkedValue == this.value2) {
        this.isOneChecked = false;
        this.isTwoChecked = true;
        this.isThreeChecked = false;
      } else if (this.checkedValue == this.value3) {
        this.isOneChecked = false;
        this.isTwoChecked = false;
        this.isThreeChecked = true;
      } else {
        this.isOneChecked = true;
        this.isTwoChecked = false;
        this.isThreeChecked = false;
      }
    }
  }

  writeValue(value: any) {
  }


  registerOnChange(fn) { this.propagateChange = fn; }
  registerOnTouched(fn) { }

  onfocusGained() {
    if (this.formErrors && this.formErrors[this.controlName]) {
      this.formErrors[this.controlName] = '';
    }
  }

  onfocusLost() {
    this.formErrors = this.validationService.validateField(this.control, this.formErrors, this.controlName, false);
  }


  onChange(value) {
    // console.log('three',value)
    this.checkedValue = this.selectedValue = value;
    this.change.emit(this.selectedValue);
  }


}
